import { render } from "./ForeignEstablishment.vue?vue&type=template&id=3ed03e26"
import script from "./ForeignEstablishment.vue?vue&type=script&lang=js"
export * from "./ForeignEstablishment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__